// extracted by mini-css-extract-plugin
module.exports = {"img":"_24FTO"};